import produce from 'immer';
import { grey } from '@material-ui/core/colors';

const INITIAL_STATE = {
  data: {
    id: 1,
    labName: 'PEERLAB',
    palette: {
      primary: grey[50],
      secondary: grey[50],
    },
    about: {
      fullName: 'Peerlab',
      email: 'adm.peerlab@gmail.com',
      phone: '47 99735-7299',
      address: 'Florianópolis',
      details:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Rhoncus dolor purus non enim praesent elementum facilisis leo vel. Risus at ultrices mi tempus imperdiet. Semper risus in hendrerit gravida rutrum quisque non tellus. Convallis convallis tellus id interdum velit laoreet id donec ultrices. Odio morbi quis commodo odio aenean sed adipiscing. Amet nisl suscipit adipiscing bibendum est ultricies integer quis. Cursus euismod quis viverra nibh cras. Metus vulputate eu scelerisque felis imperdiet proin fermentum leo. Mauris commodo quis imperdiet massa tincidunt. Cras tincidunt lobortis feugiat vivamus at augue. At augue eget arcu dictum varius duis at consectetur lorem. Velit sed ullamcorper morbi tincidunt. Lorem donec massa sapien faucibus et molestie ac.',
    },
  },
  equipment: [],
  loading: false,
};

export default function lab(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@lab/SET_LAB_STATE': {
        draft.data = action.payload.data;
        break;
      }
      case '@lab/GET_LAB_EQUIPMENT_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@lab/GET_LAB_EQUIPMENT_SUCCESS': {
        draft.equipment = action.payload.data;
        draft.loading = false;
        break;
      }
      case '@lab/GET_LAB_EQUIPMENT_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}
